<p-floatLabel>
  <p-select #operationDropdown
        id="operationDropdown"
        name="operationDropdown"
        [options]="operations"
        [(ngModel)]="selectedOperation"
        [showClear]="true"
        [checkmark]="true"
        [filter]="true"
        styleClass="w-100"
        [disabled]="isDisabled"
        (onChange)="onSelected()"
        optionLabel="label">
    <ng-template let-option pTemplate="item">
      {{ option?.label }}
    </ng-template>
  </p-select>
  <label for="operationDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::Operation') }}
    </app-label-content>
  </label>
</p-floatLabel>